import React, { Suspense, useEffect, useState, lazy } from "react";

// Libraries
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";
// Context
import GlobalContext from "./Context/Context";
// Components
import ScrollToTopButton from "./Components/ScrollToTop";
// Home
// import HomeStartupPage from "./Pages/Home/Startup/Startup";
// import BusinessOverview from "./Pages/ecd-pages/BusinessOverview";
// import ProjectsListPage from "./Pages/ecd-pages/ProjectsListPage";
// import ServicesListPage from "./Pages/ecd-pages/ServicesListPage";
// import BusinessListPage from "./Pages/ecd-pages/BusinessListPage";
// import AllServicesListPage from "./Pages/ecd-pages/AllServicesListPage";

// import GalleryPage from "./Pages/meldi-dham-pages/GalleryAlbumPage";
// import MeldiDhamEvents from "./Pages/meldi-dham-pages/MeldiDhamEvents";
// import MeldiDhamAboutUsPage from "./Pages/meldi-dham-pages/MeldiDhamAboutUsPage";
// import HomePage from "./Pages/meldi-dham-pages/HomePage";
// import MeldiDhamFQPage from "./Pages/meldi-dham-pages/MeldiDhamF&QPage";
// import MeldiDhamBlogPage from "./Pages/meldi-dham-pages/MeldiDhamBlogPage";
// import PhotoAndVideoListPage from "./Pages/meldi-dham-pages/PhotoAndVideoListPage"; // index.js or App.js
import "./i18n";
import CheckoutList from "./Pages/meldi-dham-pages/product/CheckoutList";
import PaymentPage from "./Pages/meldi-dham-pages/product/PaymentPage";
import OrderSuccess from "./Pages/meldi-dham-pages/product/OrderSuccessList";
import RamNamBookRegister from "./Pages/meldi-dham-pages/ramnambook-registration/RamNamBookRegister";
import OTPVerifyPage from "./Pages/meldi-dham-pages/ramnambook-registration/OTPVerifyPage";
import MemberDashboard from "./Pages/meldi-dham-pages/ramnambook-registration/member-dasboard/MemberDashboard";
import MemberMyProfile from "./Pages/meldi-dham-pages/ramnambook-registration/member-dasboard/MemberMyProfile";
// import BlogDetailPage from "./Pages/meldi-dham-pages/BlogDetailPage";
// import CategoryListPage from "./Pages/meldi-dham-pages/product-category/CategoryList";
// import ProductDetails from "./Pages/meldi-dham-pages/product/ProducDetails";
// import CheckoutList from "./Pages/meldi-dham-pages/auth-pages/CheckoutList";
// import LoginPage from "./Pages/meldi-dham-pages/auth-pages/LoginPage";
// import RegisterPage from "./Pages/meldi-dham-pages/auth-pages/RegisterPage";
// import LogoutPage from "./Pages/meldi-dham-pages/auth-pages/LogoutPage";

const GalleryPage = lazy(() =>
  import("./Pages/meldi-dham-pages/GalleryAlbumPage")
);
const MeldiDhamEvents = lazy(() =>
  import("./Pages/meldi-dham-pages/MeldiDhamEvents")
);
const MeldiDhamAboutUsPage = lazy(() =>
  import("./Pages/meldi-dham-pages/MeldiDhamAboutUsPage")
);
const HomePage = lazy(() => import("./Pages/meldi-dham-pages/HomePage"));
const MeldiDhamFQPage = lazy(() =>
  import("./Pages/meldi-dham-pages/MeldiDhamF&QPage")
);
// const MeldiDhamBlogPage = lazy(() =>
//   import("./Pages/meldi-dham-pages/MeldiDhamBlogPage")
// );
const PhotoAndVideoListPage = lazy(() =>
  import("./Pages/meldi-dham-pages/PhotoAndVideoListPage")
);
// const BlogDetailPage = lazy(() =>
//   import("./Pages/meldi-dham-pages/BlogDetailPage")
// );
const CategoryListPage = lazy(() =>
  import("./Pages/meldi-dham-pages/product-category/CategoryList")
);
const ProductDetails = lazy(() =>
  import("./Pages/meldi-dham-pages/product/ProducDetails")
);

const LoginPage = lazy(() =>
  import("./Pages/meldi-dham-pages/auth-pages/LoginPage")
);
const RegisterPage = lazy(() =>
  import("./Pages/meldi-dham-pages/auth-pages/RegisterPage")
);
const LogoutPage = lazy(() =>
  import("./Pages/meldi-dham-pages/auth-pages/LogoutPage")
);
const OurEvents = lazy(() => import("./Pages/ecd-pages/OurEvents"));
const EcdAboutUsPage = lazy(() => import("./Pages/ecd-pages/EcdAboutUsPage"));
const ElementPage = lazy(() => import("./Pages/Elements"));
const WhiteHeaderPage = lazy(() => import("./Pages/Header/WhiteHeaderPage"));
const DarkHeaderPage = lazy(() => import("./Pages/Header/DarkHeaderPage"));
const AboutMePage = lazy(() => import("./Pages/About/AboutMePage"));
const AboutUsPage = lazy(() => import("./Pages/About/AboutUsPage"));
const ContactUsSimplePage = lazy(() =>
  import("./Pages/Contact/ContactUsSimplePage")
);
const Footer = lazy(() => import("./Pages/Footer"));
// Footer
const FooterStyle01Page = lazy(() =>
  import("./Pages/Footer/FooterStyle01Page")
);
const FooterStyle02Page = lazy(() =>
  import("./Pages/Footer/FooterStyle02Page")
);
const OurServicesPage = lazy(() => import("./Pages/Services/OurServicesPage"));
const OurTeamPage = lazy(() => import("./Pages/AdditionalPages/OurTeamPage"));
const NotFoundPage = lazy(() => import("./Pages/404"));
const Checkout = lazy(() => import("./Pages/Shop/Checkout"));
const LoginRegister = lazy(() => import("./Pages/Shop/LoginRegister"));
function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(true);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false,
  });
  const location = useLocation();
  const isLoggedIn = !!localStorage.getItem("customer");
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/member/dashboard", { replace: true });
      setShowLogin(false);
    }
  }, []);
  // RetinaJS
  useEffect(() => {
    window.addEventListener("load", retina(document.querySelectorAll("img")));
  }, []);

  useEffect(() => {
    setTimeout(() => {
      import("./Functions/Utilities").then((module) => {
        module.SetHeaderMenuPos();
        module.setDocumentFullHeight();
      });
    }, 1000);
  }, [location]);

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
      }}
    >
      <div className="App" style={{ "--header-height": `${headerHeight}px` }}>
        {
          <main style={{ marginTop: headerHeight, marginBottom: footerHeight }}>
            <ScrollToTopButton />
            <AnimatePresence mode="wait">
              <Suspense fallback={<></>}>
                <Routes>
                  <Route
                    path="/"
                    exact
                    element={
                      <LoginPage
                        show={showLogin}
                        onHide={() => setShowLogin(false)}
                        style={{ "--base-color": "#3452ff" }}
                      />
                    }
                  />
                  <Route
                    path="/page/about"
                    element={
                      <EcdAboutUsPage style={{ "--base-color": "#0038e3" }} />
                    }
                  />
                  {/* Headers */}
                  <Route path="headers">
                    <Route path="white-header" element={<WhiteHeaderPage />} />
                    <Route path="dark-header" element={<DarkHeaderPage />} />
                  </Route>
                  {/* Footers */}
                  <Route
                    path="footers"
                    element={<Footer style={{ "--base-color": "#0038e3" }} />}
                  >
                    <Route
                      path="footer-style-01"
                      element={
                        <FooterStyle01Page
                          style={{ "--base-color": "#0038e3" }}
                        />
                      }
                    />
                    <Route
                      path="footer-style-02"
                      element={
                        <FooterStyle02Page
                          style={{ "--base-color": "#0038e3" }}
                        />
                      }
                    />
                  </Route>
                  <Route path="*" element={<NotFoundPage />} />
                  <Route
                    path="/page/error-404"
                    element={
                      <NotFoundPage style={{ "--base-color": "#0038e3" }} />
                    }
                  />
                  <Route
                    path="/page/our-team"
                    element={
                      <OurTeamPage style={{ "--base-color": "#0038e3" }} />
                    }
                  />{" "}
                  <Route
                    path="/page/contact-simple"
                    element={
                      <ContactUsSimplePage
                        style={{ "--base-color": "#0038e3" }}
                      />
                    }
                  />
                  <Route
                    path="/page/our-services"
                    element={
                      <OurServicesPage style={{ "--base-color": "#0038e3" }} />
                    }
                  />{" "}
                  <Route
                    path="/page/about"
                    element={
                      <AboutUsPage style={{ "--base-color": "#0038e3" }} />
                    }
                  />{" "}
                  <Route
                    // path="/home-business"
                    path="/index"
                    element={<HomePage style={{ "--base-color": "#3452ff" }} />}
                  />
                  {/* Shop Pages */}
                  <Route path="shop">
                    <Route path="checkout" element={<Checkout />} />
                    <Route path="login-register" element={<LoginRegister />} />
                  </Route>
                  {/* Add New Route */}
                  <Route path="/page/our-clients" element={<OurEvents />} />
                  <Route
                    path="/page/gallery&album"
                    element={<GalleryPage style={{ "--base-color": "#fff" }} />}
                  />
                  <Route
                    path="/page/meldidham-events"
                    element={
                      <MeldiDhamEvents style={{ "--base-color": "#fff" }} />
                    }
                  />
                  <Route
                    path="/page/gallery&album/:id"
                    element={
                      <PhotoAndVideoListPage
                        style={{ "--base-color": "#fff" }}
                      />
                    }
                  />
                  <Route
                    path="/page/meldi-dm-about"
                    element={
                      <MeldiDhamAboutUsPage
                        style={{ "--base-color": "#fff" }}
                      />
                    }
                  />
                  <Route
                    path="/page/f&q"
                    element={
                      <MeldiDhamFQPage style={{ "--base-color": "#fff" }} />
                    }
                  />
                  {/* <Route
                    path="/page/blog"
                    element={
                      <MeldiDhamBlogPage style={{ "--base-color": "#fff" }} />
                    }
                  /> 
                  <Route
                    path="/page/blog/:id"
                    element={
                      <BlogDetailPage style={{ "--base-color": "#fff" }} />
                    }
                  />*/}
                  {/* <Route path="/page/store" element={<CategoryListPage />} />{" "} */}
                  <Route path="/product/:id" element={<ProductDetails />} />
                  <Route path="/checkout" element={<CheckoutList />} />
                  <Route path="/payment/:id" element={<PaymentPage />} />
                  <Route path="/order-success" element={<OrderSuccess />} />
                  {/* <Route path="/login" element={<LoginPage />} /> */}
                  <Route path="/register" element={<RegisterPage />} />
                  <Route path="/logout" element={<LogoutPage />} />
                  <Route
                    path="/book-registration"
                    element={<RamNamBookRegister />}
                  />
                  <Route path="/verify-otp" element={<OTPVerifyPage />} />
                  <Route
                    path="/member/dashboard"
                    element={<MemberDashboard />}
                  />
                  <Route
                    path="/my-profile"
                    element={<MemberMyProfile />}
                  />
                </Routes>
              </Suspense>
            </AnimatePresence>
          </main>
        }
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
